import { initializeApp } from "firebase/app";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { firebaseConfig } from "./firebase-config";

if (!firebaseConfig || !firebaseConfig.apiKey || !firebaseConfig.projectId) {
    const errorMessage = "Konfigurasi Firebase tidak lengkap. Pastikan file firebase-config.ts sudah digenerate.";
    console.error(errorMessage);
    if (typeof window !== 'undefined') {
        document.body.innerHTML = `<div style="color: red; padding: 20px; font-family: sans-serif;"><h1>Error Konfigurasi</h1><p>${errorMessage}</p></div>`;
    }
    throw new Error(errorMessage);
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Firestore with modern persistence settings
// NOTE (perf - data seluler): persistentLocalCache membuat data shift &
// lokasi presensi yang PERNAH di-sinkron sebelumnya tetap tersedia dari cache
// lokal saat jaringan lemah/putus, sehingga alur presensi tidak menggantung.
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  })
});

export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'asia-southeast2'); // Match region in CLOUDFUNCTIONS.md
